// extracted by mini-css-extract-plugin
export default {"tableHeader":"TableHeader_tableHeader__dUhk3"};